<template>
    <div class="img">
        <div class="com_img_box"
             @mouseup="mouseUp"
             @mouseleave="mouseLeave"
             id="img_box">
            <el-image
                    class="image"
                    id="rotate_img"
                    v-if="imgUrl"
                    :src="imgUrl"
                    @mousedown="mouseDown"
                    @mousemove="mouseMove"
                    @mousewheel="mouseWheel"
                    :style="imgStyle"
                    fit="contain">
                <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                </div>
            </el-image>
        </div>
        <div class="btn_box">
            <el-button size="small" @click="refreshImg()">重置</el-button>
            <el-button size="small" @click="changeImgSize(1,'btn')">放大</el-button>
            <el-button size="small" @click="changeImgSize(-1, 'btn')">缩小</el-button>
            <el-button size="small" @click="changeImgRotate(-1)">左旋</el-button>
            <el-button size="small" @click="changeImgRotate(1)">右旋</el-button>
        </div>
    </div>
</template>

<script>
    import {clone} from "@/global/utils";

    export default {
        name: "imgView",
        data() {
            return {
                down_: false,
                top: 0,
                left: 0,

                width: 0,
                height: 0,
                rotate: 0,
                rotate_deg: 0,

                start_x: 0,
                start_y: 0,
                move_x: 0,
                move_y: 0,

                now_mouse_x: 0,
                now_mouse_y: 0,

                base_width: 0,
                base_height: 0,

                ratio_width_height: null,
            }
        },
        props: [
            'imgUrl'
        ],
        computed: {
            imgStyle() {
                return {
                    // transform: `scale(${this.zoom}) rotateZ(${this.rotate_deg}deg)`,
                    transform: `rotateZ(${this.rotate_deg}deg)`,
                    left: this.left + this.move_x + 'px',
                    top: this.top + this.move_y + 'px',
                    width: this.width + 'px',
                    height: this.height + 'px',
                };
            },
        },
        watch: {
        },
        mounted() {
            this.$nextTick(() => {
                this.getWidthHeight()
            })
        },
        methods: {
            getWidthHeight() {
                const img_box = document.getElementById('img_box');
                this.width = img_box.offsetWidth;
                this.height = img_box.offsetHeight;
                this.ratio_width_height = this.width / this.height; // 宽高比
                console.log(this.width, this.height, '-----图片宽高');
            },
            refreshImg() {
                this.rotate = 0;
                this.rotate_deg = 0;
                this.left = 0;
                this.top = 0;
                this.getWidthHeight()
            },

            mouseDown(e) {
                e.preventDefault();
                this.down_ = true;
                this.start_x = e.clientX;
                this.start_y = e.clientY;
            },
            mouseUp(e) {
                e.preventDefault();
                this.down_ = false;
                this.top = this.top + this.move_y;
                this.left = this.left + this.move_x;
                this.move_x = 0;
                this.move_y = 0;
            },
            mouseLeave(e) {
                e.preventDefault();
                this.down_ = false;
                this.top = this.top + this.move_y;
                this.left = this.left + this.move_x;
                this.move_x = 0;
                this.move_y = 0;
            },
            mouseMove(e) {
                e.preventDefault();
                this.now_mouse_x = e.offsetX;
                this.now_mouse_y = e.offsetY;
                this.base_width = parseInt(clone(this.width));
                this.base_height = parseInt(clone(this.height));
                if(this.down_) {
                    // console.log(this.now_mouse_x, this.base_width,'move');
                    this.move_x = e.clientX - this.start_x;
                    this.move_y = e.clientY - this.start_y;
                }
            },

            mouseWheel(event) {
                event.preventDefault();
                var delta = 0;
                if (!event) return;
                if (event.wheelDelta) {
                    delta = event.wheelDelta / 120;
                    if (window.opera) delta = -delta;
                } else if (event.detail) {
                    delta = -event.detail / 3;
                }
                this.changeImgSize(delta)
            },
            getMouse_x_y(type) {
                let ratio = 1;
                if (type === 'x') {
                    if (this.rotate_deg == 0) {
                        ratio = this.now_mouse_x / this.base_width * this.width;
                    } else if (this.rotate_deg == 90 || this.rotate_deg == -270) {
                        ratio = .5 * this.width;
                        // ratio = this.now_mouse_x / this.base_width * this.width;
                        // ratio = (this.now_mouse_y / this.base_height) * this.height;
                    } else if (this.rotate_deg == 180 || this.rotate_deg == -180) {
                        ratio = (1 - this.now_mouse_x / this.base_width) * this.width;
                    } else if (this.rotate_deg == 270 || this.rotate_deg == -90) {
                        ratio = .5 * this.width;
                        // ratio = (1 - this.now_mouse_x / this.base_width) * this.width;
                        // ratio = (1 - this.now_mouse_y / this.base_height) * this.height;
                    }
                }
                if (type === 'y') {
                    if (this.rotate_deg == 0) {
                        ratio = this.now_mouse_y / this.base_height * this.height;
                    } else if (this.rotate_deg == 90 || this.rotate_deg == -270) {
                        ratio = .5 * this.height;
                        // ratio = this.now_mouse_y / this.base_height * this.height;
                        // ratio = (this.now_mouse_x / this.base_width) * this.width;
                    } else if (this.rotate_deg == 180 || this.rotate_deg == -180) {
                        ratio = (1 - this.now_mouse_y / this.base_height) * this.height;
                    } else if (this.rotate_deg == 270 || this.rotate_deg == -90) {
                        ratio = .5 * this.height;
                        console.log(this.now_mouse_y / this.base_height, '175');
                        // ratio = (1 - this.now_mouse_y / this.base_height) * this.height;
                        // ratio = (1 - this.now_mouse_x / this.base_width) * this.width;
                    }
                }
                return ratio;
            },
            changeImgSize(delta, type) {
                let x = 1, y = 1;
                if (type === 'btn') {
                    x = .5 * this.width;
                    y = .5 * this.height;
                } else {
                    x = this.getMouse_x_y('x');
                    y = this.getMouse_x_y('y');
                }
                if (delta > 0) {
                    this.width = this.width * 1.1;
                    this.height = this.height * 1.1;

                    this.top = this.top - y * .1;
                    this.left = this.left - x * .1;
                } else if (delta < 0) {
                    if (this.width > 400) {
                        this.width = this.width * 0.9;
                        this.height = this.height * 0.9;

                        this.top = this.top + .1 * y;
                        this.left = this.left + .1 * x;
                    }
                }
            },

            changeImgRotate(val) {
                this.rotate += val;
                this.rotate_deg = (90 * this.rotate) % 360;
            }
        }
    }
</script>

<style scoped lang="scss">
    .img {
        width: 100%;
        height: 100%;
        background: #F2F6FC;
        position: relative;
        .com_img_box {
            height: 100%;
            width: 100%;
            overflow: hidden;
            box-sizing: border-box;
            position: relative;
            .image {
                width: 100%;
                height: 100%;
                position: absolute;
            }
            z-index: 99;
        }
        .btn_box {
            position: absolute;
            top: 0;
            right: 0;
            height: 50px;
            line-height: 50px;
            z-index: 100;
            text-align: right;
            padding: 0 10px;
            box-sizing: border-box;
        }
    }
</style>